// extracted by extract-css-chunks-webpack-plugin
module.exports = {"Switch":"Switch_24q26_v16-5-1","Switch__Flat":"Switch__Flat_kNskP_v16-5-1","Switch__Tiny":"Switch__Tiny_nsOLn_v16-5-1"};